/* Префикс старых адресов страницы (напечатанные QR, старые сборки мобилки и терминала, возвраты старого бэка):
 *  те же пути с ним открывают тот же экран без смены адреса (web-hosts.md, pay-host R-1). */
export const LEGACY_PATH_PREFIX = '/client';

/* Базовый путь маршрутизатора по открытому адресу: с ним маршруты совпадают с каноническими путями,
 *  а внутренние переходы сохраняют префикс, так что перезагрузка открывает тот же экран. */
export const getRouterBasename = (pathname: string): string =>
  pathname === LEGACY_PATH_PREFIX || pathname.startsWith(`${LEGACY_PATH_PREFIX}/`) ? LEGACY_PATH_PREFIX : '';
